import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { cn, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@crehana/compass.ui/v2';
import { TargetSegmentEnum } from "../shared/types";
import { ItemList } from "./components/item-list";
import { useAddI18nLocales, useInputFilterTranslation } from "./i18n";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var HanaInputFilter = function HanaInputFilter(_ref) {
  var filters = _ref.filters,
    items = _ref.items,
    selectedItem = _ref.selectedItem,
    onSelectItem = _ref.onSelectItem,
    _ref$targetSegment = _ref.targetSegment,
    targetSegment = _ref$targetSegment === void 0 ? TargetSegmentEnum.EndUser : _ref$targetSegment;
  useAddI18nLocales();
  var _useInputFilterTransl = useInputFilterTranslation(),
    t = _useInputFilterTransl.t;
  var _useState = useState(filters.find(function (filter) {
      return filter.isDefault;
    }) || filters[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilter = _useState2[0],
    setSelectedFilter = _useState2[1];
  var renderIcon = function renderIcon(keyOption) {
    var item = filters.find(function (item) {
      return t(item.labelKey) === keyOption;
    });
    return item !== null && item !== void 0 && item.Icon ? /*#__PURE__*/_jsx(item.Icon, {
      size: 12,
      className: cn('[&>svg>g]:tw-fill-neutral-light-800')
    }) : null;
  };
  var handleSelectItem = function handleSelectItem(item) {
    var filterItem = filters.find(function (filter) {
      return t(filter.labelKey) === (item === null || item === void 0 ? void 0 : item.category);
    });
    onSelectItem(_objectSpread(_objectSpread({}, item), {}, {
      icon: {
        Component: filterItem === null || filterItem === void 0 ? void 0 : filterItem.Icon,
        className: (filterItem === null || filterItem === void 0 ? void 0 : filterItem.iconClassName) || ''
      }
    }));
  };
  if (targetSegment === TargetSegmentEnum.Admin) {
    return /*#__PURE__*/_jsxs("div", {
      className: "tw-w-full tw-py-[1.4rem] tw-max-w-[60rem]",
      children: [/*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          className: "tw-font-link1 tw-neutral-light-800 tw-mb-[1.8rem] tw-mx-2.4",
          children: t('LABEL_FILTER_TITLE')
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-w-fit tw-flex tw-items-center tw-rounded-full tw-p-0.8 tw-bg-neutral-light-300 tw-gap-x-1.2 tw-mb-0.4 tw-mx-2.4",
          children: filters.map(function (item) {
            return /*#__PURE__*/_jsx(TooltipProvider, {
              children: /*#__PURE__*/_jsx(Tooltip, {
                delayDuration: 300,
                children: /*#__PURE__*/_jsxs(TooltipTrigger, {
                  children: [/*#__PURE__*/_jsxs("div", {
                    "aria-hidden": "true",
                    onClick: function onClick() {
                      return setSelectedFilter(item);
                    },
                    className: cn('tw-flex tw-items-center tw-gap-x-0.8 tw-rounded-full tw-cursor-pointer tw-transition-all tw-duration-200 tw-ease-in-out', t(selectedFilter.labelKey) === t(item.labelKey) && "tw-px-1.6 tw-py-[0.9rem] ".concat(item.backgroundColor, " "), t(selectedFilter.labelKey) !== t(item.labelKey) && 'tw-p-[0.9rem]', item.className),
                    children: [item.Icon && /*#__PURE__*/_jsx(item.Icon, {
                      className: item.iconClassName,
                      size: 24
                    }), t(selectedFilter.labelKey) === t(item.labelKey) && /*#__PURE__*/_jsx("span", {
                      className: "tw-font-body5 tw-font-subtitle6",
                      children: t(item.labelKey)
                    })]
                  }), /*#__PURE__*/_jsx(TooltipContent, {
                    children: /*#__PURE__*/_jsx("p", {
                      className: "tw-font-body5 tw-neutral-light-800",
                      children: t(item.labelKey)
                    })
                  })]
                })
              })
            }, "filter-".concat(t(item.labelKey)));
          })
        })]
      }), /*#__PURE__*/_jsx(ItemList, {
        items: items.filter(function (item) {
          return selectedFilter.isDefault || item.category === t(selectedFilter.labelKey);
        }),
        selectedItem: selectedItem,
        onSelectItem: handleSelectItem,
        showCategoryIcon: targetSegment === TargetSegmentEnum.Admin && selectedFilter.isDefault,
        renderCategoryIcon: renderIcon
      })]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "tw-w-full tw-py-[1.4rem] tw-max-w-[60rem]",
    children: /*#__PURE__*/_jsx(ItemList, {
      items: items.filter(function (item) {
        return selectedFilter.isDefault || item.category === t(selectedFilter.labelKey);
      }),
      selectedItem: selectedItem,
      onSelectItem: handleSelectItem,
      showCategoryIcon: false
    })
  });
};